/<template>
    <v-btn
        fab
        id="record-button"
        v-bind="$attrs"
        v-on="$listeners"
        :class="{
            'touched': touched
        }"
        @mousedown="handleMouseDown"
        @mouseup="handleMouseUp"
        @touchstart="handleTouchStart"
        @touchend="handleTouchEnd"
        @touchmove="handleTouchMove"
    />
</template>

<script>
import {isSafari} from "../../../helpers/functions";
export default {
    name: "RecordButton",
    data: () => ({
        clearableInterval: '',
        isVideoStart: false,
        zoomFactor: 1.0,
        minZoom: 0.5,
        maxZoom: 4.0,
        touchStartY: null,
        initialZoom: false,
        printr: null,
    }),
    props: {
        disableVideo: {
            type: Boolean,
            default: false,
        },
        useTimer: {
            type: Boolean,
            default: false,
        },
        touched: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        handleTouchStart(event) {
            if (this.disableVideo || this.useTimer) {
                return
            }

            this.touchStartY = event.touches[0].clientY;
            this.clearableInterval = setTimeout(() => {
                    this.isVideoStart = true;
                    this.$emit('videoStart')
                }, 1000
            )
        },
        handleTouchEnd() {
            if (this.isVideoStart === true || this.useTimer) {
                this.$emit('videoEnd')
                this.isVideoStart = false;
                this.initialZoom = false;
            } else {
                this.$emit('photoShoot')
            }

            clearTimeout(this.clearableInterval)
        },
        handleTouchMove(event) {
            if (!this.isVideoStart || isSafari()) return;

            const currentY = event.touches[0].clientY;
            const deltaY = currentY - this.touchStartY;

            if (deltaY < -30 || deltaY > 30) {
                this.initialZoom = true;
            }

            if (this.initialZoom) {
                const zoomStep = isSafari() ? 0.03 : 0.05;

                this.printr = zoomStep;

                if (deltaY > 0) {
                    // Move finger down: Zoom out
                    this.zoomFactor = Math.max(this.minZoom, this.zoomFactor - zoomStep);
                    this.touchStartY = currentY;
                } else if (deltaY < 0) {
                    // Move finger up: Zoom in
                    this.zoomFactor = Math.min(this.maxZoom, this.zoomFactor + zoomStep);
                    this.touchStartY = currentY;
                }
                this.$emit('zoom-change', this.zoomFactor)
            }
        },
        handleMouseDown() {
            this.handleTouchStart()
        },
        handleMouseUp() {
            this.handleTouchEnd()
        },
    }
}
</script>

<style scoped lang="scss">
@import '@/sass/modules/_variables.scss';

#record-button {
    width: 74px;
    height: 74px;
    border: 6px solid grey;
    border-radius: 64px;
    background-color: white;
    background-origin: border-box;
    background-clip: content-box, border-box;
    transition: 0.5s;
}

#record-button.touched {
    width: 84px;
    height: 84px;
    border: 6px solid transparent;
    border-radius: 64px;
    background-image: initial;
    background-origin: border-box;
    background-clip: content-box, border-box;
}
</style>
